export default {"src":"/_next/static/media/roadblock.516e8071.gif","height":400,"width":400};